import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

const mfaHasFlagShortTermQuery = gql`
  query MFAHasFlagShortTerm {
    mfaHasFlagShortTerm
  }
`

export const mfaHasFlagShortTermKey = getQueryNames(mfaHasFlagShortTermQuery)[0]

export {mfaHasFlagShortTermQuery}
